import Vue from "vue";

const offboardingTasks = {
  namespaced: true,
  state: {
    tasks: null,
  },
  mutations: {
    setOffBoardingTasks(state, newData) {
      state.tasks = newData;
    },
    addOffTask(state, newTask) {
      state.tasks.push(newTask.task);
    },
    setNewTimeFrame(state, payLoad) {
      const task = state.tasks.find((x) => x.id === payLoad.id);

      Vue.set(task, "type", payLoad.type);
    },
  }, // change state
  getters: {
    getBeforeLastDay: (state) => {
      return state.tasks.filter((task) => task.type === "beforeLastDay");
    },
    getLastDay: (state) => {
      return state.tasks.filter((task) => task.type === "lastDay");
    },
    getAfterLastDay: (state) => {
      return state.tasks.filter((task) => task.type === "afterLastDay");
    },
  }, // get specific state
  actions: {}, // tell what to do
};

export default offboardingTasks;
